import axios from 'axios';

// 由 .env.{APP_ENV} 决定：development -> ''（走本地代理），test / production -> 各自的域名
const BASE_URL = process.env.REACT_APP_API_URL || ''
// const BASE_URL = 'https://admin.northbundforum.com'

const api = {
  post(url, data,) {
    return new Promise((resolve, reject) => {
      const apiUrl = BASE_URL + url
      axios.post(`${apiUrl}`, data,).then(response => {
        if (response.status === 200) {
          const resp = response.data
          // if(resp.code === 0) {
          resolve(response.data)
          // } else {
          //   reject(response)
          // }
        } else {
          reject(response)
        }
      }).catch(error => reject(error));
    })
  },
  get(url, params) {
    const apiUrl = BASE_URL + url
    return new Promise((resolve, reject) => {
      axios.get(`${apiUrl}`, { params }).then(response => {
        if (response.status === 200) {
          const resp = response.data
          // if(resp.code === 0) {
          resolve(response.data)
          // } else {
          //   reject(response)
          // }
        } else {
          reject(response)
        }
      }).catch(error => reject(error));
    });
  }
}


export default api